import './Analytics.scss';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import api from '../../services/api';

const EVENT_TYPE_LABELS = {
  venue_view: 'Venue Views',
  event_view: 'Event Views',
  search: 'Searches',
  venue_tap: 'Venue Taps',
  event_tap: 'Event Taps',
  bottle_service_view: 'Bottle Service Views',
  bottle_purchase_started: 'Purchase Attempts',
  ai_query: 'AI Queries',
  map_opened: 'Map Opens',
  venue_favorited: 'Venue Favorites',
  view_tables_clicked: 'Table Views',
  join_guestlist_clicked: 'Guest List Clicks',
  ad_impression: 'Ad Impressions',
  ad_click: 'Ad Clicks',
  ad_dismiss: 'Ad Dismissals',
  app_update_popup_shown: 'App Popup Shown',
  app_update_popup_tapped: 'App Popup Tapped',
  force_update_shown: 'Update Screen Shown',
  force_update_tapped: 'Update Tapped',
};

const EventsDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const eventType = searchParams.get('event_type');
  const days = searchParams.get('days') || 30;

  const title = EVENT_TYPE_LABELS[eventType] || eventType || 'Events';

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/analytics/event-log?days=${days}&event_type=${eventType}&limit=100`);
      setEvents(data.data);
    } catch (error) {
      console.error('Error fetching event log:', error);
    } finally {
      setLoading(false);
    }
  }, [eventType, days]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  };

  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section className="analytics">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
              <button
                onClick={() => navigate('/analytics')}
                style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 8, padding: '8px 16px', color: '#fff', cursor: 'pointer', fontSize: 14 }}>
                Back
              </button>
              <h1 className="analytics__title" style={{ margin: 0 }}>{title} — All Events</h1>
            </div>

            <div className="analytics__table" style={{ maxWidth: '100%' }}>
              {loading ? (
                <div className="analytics__loading">Loading...</div>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Venue</th>
                      <th>Time</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((e, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          {e.photo_url ? (
                            <img src={e.photo_url} alt="" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ width: 32, height: 32, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                              {(e.firstName?.[0] || '?').toUpperCase()}
                            </div>
                          )}
                          {e.firstName} {e.lastName}
                        </td>
                        <td>{e.venue_name || '—'}</td>
                        <td style={{ color: 'rgba(255,255,255,0.5)', whiteSpace: 'nowrap' }}>{formatDate(e.created_at)}</td>
                        <td>
                          <button
                            onClick={() => navigate(`/users/${e.user_id}?tab=activity`)}
                            className="text-link">
                            Activity
                          </button>
                        </td>
                      </tr>
                    ))}
                    {events.length === 0 && (
                      <tr><td colSpan={5} style={{ textAlign: 'center', color: 'rgba(255,255,255,0.3)' }}>No events found</td></tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </section>
        </article>
      </div>
    </main>
  );
};

export default EventsDetail;
